import styled, { css } from 'styled-components';
import { AScrimIntensity } from './AScrim.types';

const getIntensityStyles = (intensity: AScrimIntensity) => {
  switch (intensity) {
    case AScrimIntensity.None:
      return css`
        background-color: var(--t-color-scrim-0);
      `;
    case AScrimIntensity.Full:
      return css`
        background-color: var(--t-color-scrim-100);
      `;
    default: {
      const _exhaustive: never = intensity;
      return css``;
    }
  }
};

export const Wrapper = styled.div<{ $intensity: AScrimIntensity }>`
  position: absolute;
  inset: 0;
  pointer-events: none;

  ${({ $intensity }) => getIntensityStyles($intensity)}

  @media (prefers-reduced-transparency: reduce) {
    background-color: var(--t-color-scrim-100);
  }
`;
